import styled from "styled-components";

export const MapDiv = styled.div`
   width: calc(100% - 20px);
   height: 90vh;
   margin: 10px;
`;
export const Img = styled.img`
   width: 25px;
   height: 25px;
`;
export const InfoViewPort = styled.pre`
   display: block;
   position: relative;
   float: left;
   margin: 0px auto;
   width: 30%;
   padding: 10px;
   border: none;
   border-radius: 3px;
   font-size: 12px;
   text-align: center;
   color: #222;
`;